import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { getCartInfo } from "@/common/service/default-mapper";
import _ from 'lodash';

export default (planMapJSON) => {
  const pbxPlans = _.concat(planMapJSON.pbxAudio?.pbx?.plans || [], planMapJSON.pbxAudio?.smbInfo?.pbx?.plans || []);
  return pbxPlans.filter(item => item.category_code === 'ZPA').map((item) => {
    return {
      type: planTypes.ZOOM_PHONE$ZPA,
      category: item.category_code,
      region: item.region,
      sub_type: item.sub_type,
      parent_category: 'ZMV',
      plan_code: item.plan_code,
      plan_type: item.plan_type,
      amount: item.amount,
      cartInfo: getCartInfo(),
      max: 99,
      min: 1,
      billing_cycle: item.is_payg ? BILLING_CYCLE.PAY_AS_YOU_GO : item.billing_cycle,
      is_payg: item.is_payg,
      dependBasePlanTypeList: [planTypes.ZOOM_PHONE, planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE],
      supportCoupon: true,
      typeNameKey: 'billing.pbx.cart_name.ZPA',
      planNameKey: 'billing.pbx.plan_name.ZPA',
      licenseDependBasePlanTypeList: [planTypes.ZOOM_PHONE, planTypes.ZONE_PRO_PLUS],
    };
  });
}
